module Blocks.Interfaces {
    export interface ILoggerService {
        error(message: any, data?: any, title?: string): void;
        info(message: any, data?: any, title?: string): void;
        warn(message: any, data?: any, title?: string): void;
        success(message: any, data?: any, title?: string): void;
    }
}